import React from "react";
import {
  Box,
  Typography,
  Popover,
  Divider,
  Avatar,
  Button,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

const UserProfileDialog = ({ anchorEl, handleClose, userData }) => {
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const id = open ? "user-profile-popover" : undefined;
  const userInitial = userData.name ? userData.name.charAt(0).toUpperCase() : "U";

  const handleLogout = () => {
    localStorage.clear();
    handleClose();
    window.location.href = import.meta.env.VITE_APP_MAIN_LOGOUT_URL;
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        sx: {
          mt: 1.5,
          width: 240,
          borderRadius: "12px",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
          border: "1px solid #f0f0f0",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Avatar
          sx={{
            width: 48,
            height: 48,
            margin: "0 auto",
            mb: 1,
            bgcolor: "#00675d",
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          {userInitial}
        </Avatar>
        <Typography
          sx={{
            fontWeight: "700",
            textTransform: "capitalize",
            color: "#333",
            fontSize: "13px",
            lineHeight: 1.2,
          }}
        >
          {userData.name || "User"}
        </Typography>
        <Typography sx={{ color: "#888", fontSize: "11.5px", mt: 0.3 }}>
          {userData.email}
        </Typography>
        <Typography
          sx={{
            color: "#00675d",
            fontSize: "11px",
            fontWeight: "600",
            mt: 0.5,
            textTransform: "uppercase",
            letterSpacing: "0.5px"
          }}
        >
          {userData.isOverAllAdmin ? "OverAll Admin" : userData.role}
        </Typography>
      </Box>

      <Divider />

      <Box sx={{ p: 0.5 }}>
        <Button
          fullWidth
          size="small"
          startIcon={<LogoutIcon sx={{ fontSize: "16px !important" }} />}
          onClick={handleLogout}
          sx={{
            color: "#ff4d4f",
            textTransform: "none",
            fontSize: "13px",
            fontWeight: "600",
            py: 0.7,
            "&:hover": {
              bgcolor: "rgba(255, 77, 79, 0.04)",
            },
          }}
        >
          Sign Out
        </Button>
      </Box>
    </Popover>
  );
};

export default UserProfileDialog;
